"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./SelectComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Option = _antd.Select.Option,
    OptGroup = _antd.Select.OptGroup;

var SelectComponent = function SelectComponent(_ref) {
  var _ref$showArrow = _ref.showArrow,
      showArrow = _ref$showArrow === void 0 ? false : _ref$showArrow,
      isGroup = _ref.isGroup,
      _ref$showSearch = _ref.showSearch,
      showSearch = _ref$showSearch === void 0 ? false : _ref$showSearch,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? "single" : _ref$mode,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Select label" : _ref$placeholder,
      optionData = _ref.optionData,
      _ref$notFoundContent = _ref.notFoundContent,
      notFoundContent = _ref$notFoundContent === void 0 ? null : _ref$notFoundContent,
      defaultValue = _ref.defaultValue,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$clearIcon = _ref.clearIcon,
      clearIcon = _ref$clearIcon === void 0 ? false : _ref$clearIcon,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      _ref$allowClear = _ref.allowClear,
      allowClear = _ref$allowClear === void 0 ? false : _ref$allowClear,
      _ref$defaultOpen = _ref.defaultOpen,
      defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      onChange = _ref.onChange,
      id = _ref.id,
      value = _ref.value,
      height = _ref.height,
      width = _ref.width,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      name = _ref.name,
      onClear = _ref.onClear,
      handleSearchData = _ref.handleSearchData,
      keyName = _ref.keyName,
      onSearch = _ref.onSearch,
      filterOption = _ref.filterOption,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading;

  var getOptionList = function getOptionList(list) {
    return list && (list === null || list === void 0 ? void 0 : list.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement(Option, {
        key: item.key || item.id,
        value: item.value,
        disabled: item.disable || false
      }, item.icon && /*#__PURE__*/_react["default"].createElement("img", {
        src: item.icon
      }), item.label || item[keyName]);
    }));
  };

  var options = [];

  if (isGroup) {
    options = optionData && optionData.map(function (data) {
      var optionList = getOptionList(data.list);
      return /*#__PURE__*/_react["default"].createElement(OptGroup, {
        key: data.groupKey,
        label: data.groupLabel
      }, optionList);
    });
  } else {
    options = getOptionList(optionData);
  }

  var optionsFilter = function optionsFilter(input, option) {
    handleSearchData(input);
    return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };

  return isGroup ? /*#__PURE__*/_react["default"].createElement(_antd.Select, {
    "data-testid": "group-select-component",
    showArrow: showArrow,
    showSearch: showSearch,
    style: {
      width: width ? width : "16.25rem",
      height: height ? height : "1.75rem"
    },
    mode: mode,
    placeholder: placeholder,
    notFoundContent: notFoundContent,
    defaultValue: defaultValue,
    disabled: disabled,
    clearIcon: clearIcon,
    autoFocus: autoFocus,
    allowClear: allowClear,
    defaultOpen: defaultOpen,
    size: size,
    onChange: onChange,
    maxTagCount: "responsive",
    listItemHeight: "2rem",
    listHeight: "8rem",
    id: id,
    value: value,
    className: "".concat(className, " iiht-ant-select"),
    name: name,
    onClear: onClear,
    dropdownClassName: "iiht-ant-select-dropdown",
    getPopupContainer: function getPopupContainer() {
      return document.getElementById("app-container");
    },
    loading: loading
  }, options) : /*#__PURE__*/_react["default"].createElement(_antd.Select, {
    "data-testid": "select-component",
    showSearch: showSearch,
    onSearch: onSearch,
    showArrow: showArrow,
    style: {
      width: width ? width : "10rem",
      height: height ? height : "1.75rem"
    },
    mode: mode,
    placeholder: placeholder,
    notFoundContent: notFoundContent,
    defaultValue: defaultValue,
    disabled: disabled,
    clearIcon: clearIcon,
    autoFocus: autoFocus,
    allowClear: allowClear,
    defaultOpen: defaultOpen,
    size: size,
    onChange: onChange,
    maxTagCount: "responsive",
    filterOption: filterOption !== undefined ? filterOption : optionsFilter,
    listItemHeight: "2rem",
    listHeight: "8rem",
    id: id,
    value: value,
    className: "".concat(className, " iiht-ant-select"),
    name: name,
    onClear: onClear,
    dropdownClassName: "iiht-ant-select-dropdown",
    getPopupContainer: function getPopupContainer() {
      return document.getElementById("app-container");
    },
    loading: loading
  }, options);
};

var _default = SelectComponent;
exports["default"] = _default;